<template>
  <el-form :model="form" :rules="rules"></el-form>
</template>

<script>
export default {
  data () {
    return {
      form: {},
      rules: {}
    }
  }
}
</script>
